import { useAppEmbedStatus } from "@/app/home/hooks/use-app-embed-status";
import { JURNI_CORE_TASK_ID } from "@/constants/getting-started";
import { useGettingStartedProgress } from "@/hooks/use-getting-started-progress";

// Account Setup tasks with Jurni Core following live detection. The task completes only once
// the script is detected, and the live check catches a script turned off later. When a finished
// setup loses the script, Jurni Core reopens as the one task left and can't be dismissed.
export const useGettingStartedTasks = () => {
  const { data, isSuccess } = useGettingStartedProgress();
  const { data: appEmbedStatus } = useAppEmbedStatus();
  const jurniCoreTask = data?.tasks.find(
    (task) => task.id === JURNI_CORE_TASK_ID,
  );
  // Both use the same detection; the live check is fresher than the polled progress.
  const isJurniCoreMissing =
    appEmbedStatus !== undefined
      ? !appEmbedStatus.isEnabled
      : !!jurniCoreTask && !jurniCoreTask.completed;
  const isJurniCoreReopened = !!data?.completedAt && isJurniCoreMissing;

  const tasks = (data?.tasks ?? []).map((task) =>
    task.id === JURNI_CORE_TASK_ID
      ? {
          ...task,
          completed: !isJurniCoreMissing,
          dismissed: !isJurniCoreReopened && task.dismissed,
          dismissible: !isJurniCoreReopened,
          showJurniCoreWarning: isJurniCoreMissing,
        }
      : { ...task, dismissible: true, showJurniCoreWarning: false },
  );

  return {
    isSuccess,
    completedAt: data?.completedAt,
    tasks,
    isJurniCoreMissing,
  };
};
